/**
 * Structural course routes follow the interface; scene titles stay in the target language.
 * Retain renamed roots in `courseAliases` and old segment → internal key in `aliases`.
 * Runtime redirects and static redirect generation both consume these aliases.
 */
import de from '../i18n/locales/de/app/course-route-slugs.json' with {type:'json'};
import en from '../i18n/locales/en/app/course-route-slugs.json' with {type:'json'};
import ar from '../i18n/locales/ar/app/course-route-slugs.json' with {type:'json'};
import tr from '../i18n/locales/tr/app/course-route-slugs.json' with {type:'json'};
import uk from '../i18n/locales/uk/app/course-route-slugs.json' with {type:'json'};
import ru from '../i18n/locales/ru/app/course-route-slugs.json' with {type:'json'};
import es from '../i18n/locales/es/app/course-route-slugs.json' with {type:'json'};
import vi from '../i18n/locales/vi/app/course-route-slugs.json' with {type:'json'};
import pl from '../i18n/locales/pl/app/course-route-slugs.json' with {type:'json'};
import el from '../i18n/locales/el/app/course-route-slugs.json' with {type:'json'};
import fr from '../i18n/locales/fr/app/course-route-slugs.json' with {type:'json'};
import sl from '../i18n/locales/sl/app/course-route-slugs.json' with {type:'json'};

export const COURSE_ROUTE_LOCALES=Object.freeze(Object.fromEntries(
  Object.entries({de,en,ar,tr,uk,ru,es,vi,pl,el,fr,sl}).map(([ui,locale])=>[
    ui,Object.freeze({...locale,segments:Object.freeze(locale.segments)}),
  ]),
));
export const COURSE_ROUTE_SEGMENTS=Object.freeze(Object.fromEntries(
  Object.entries(COURSE_ROUTE_LOCALES).map(([ui,locale])=>[ui,locale.segments]),
));
export const LEGACY_COURSE_SECTIONS = Object.freeze(Object.values(COURSE_ROUTE_LOCALES).flatMap(locale => locale.courseAliases || []));
